import { AccordionProps, AccordionItem } from 'components/partials/accordion';
import { PrimaryButtonProps } from "components/partials/buttons/primary-button";

// import helpers
import { getLinkDataFromDato } from 'helpers/get-link-data';

export const getAccordionFaq = (faqs: Queries.FaqBlockFragment[]): AccordionProps | null => {

    let items = faqs.map((faq): AccordionItem | undefined => {

        if (!faq) return undefined;

        let buttonLink: PrimaryButtonProps | undefined = undefined;

        let linkData = getLinkDataFromDato(faq.link?.link);

        let linkLabel = linkData?.label ?? linkData?.title ?? 'Learn More';

        if (linkData) {
            buttonLink = {
                buttonText: linkLabel,
                buttonUrl: linkData.url ?? "#",
                target: linkData.target ?? "_self",
                plain: true
            };
        }

        return {
            headline: faq?.question || 'Error: question missing',
            content: faq?.answer || 'Error: answer missing',
            isOpen: false,
            buttonLink: buttonLink
        }

    }).filter((faq): faq is AccordionItem => faq != undefined) || [];

    let props: AccordionProps = {
        headline: "FAQ",
        items: items
    };

    return items.length > 0 ? props : null;

}